import { createRouter, createWebHistory } from 'vue-router'
import 'bootstrap/dist/css/bootstrap.min.css'


const routes = [
  {
    path: '/',
    component: () => import('@/views/ConsultaContatosView.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/HomeView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/manutencao-contatos',
    name: 'manutencao-contatos',
    component: () => import('../views/ManutencaoContatosView.vue'),
    meta: { requiresAuth: true, requiredRole: 'ADMINISTRADOR' }                                                                  
  },
  {
    path: '/manutencao-contatos-telefonia',
    name: 'manutencao-contatos-telefonia',
    component: () => import('../views/ManutencaoContatosTelefoniaView.vue'),
    meta: { requiresAuth: true, requiredRole: 'Operador Telefonia' }
  },
  {
    path: '/manutencao-perfil',
    name: 'manutencao-perfil',
    component: () => import('../views/ManutencaoPerfilView.vue'),
    meta: { requiresAuth: true, requiredRole: 'ADMINISTRADOR' }
  },
  {
    path: '/manutencao-contatos-externo',
    name: 'manutencao-contatos-externo',
    component: () => import('@/views/ManutencaoContatosExternoView.vue'),
    meta: { requiresAuth: true, requiredRole: 'ADMINISTRADOR' }
  },
  {
    path: '/manutencao-contatos-externo-telefonia',
    name: 'manutencao-contatos-externo-telefonia',
    component: () => import('@/views/ManutencaoContatosExternoTelefoniaView.vue'),
    meta: { requiresAuth: true, requiredRole: 'Operador Telefonia' }
  },
  {
    path: '/manutencao-contatos-unidade',
    name: 'manutencao-contatos-unidade',
    component: () => import('@/views/ManutencaoContatosUnidadeView.vue'),
    meta: { requiresAuth: true, requiredRole: 'ADMINISTRADOR' }
  },
  {
    path: '/manutencao-contatos-unidade-telefonia',
    name: 'manutencao-contatos-unidade-telefonia',
    component: () => import('@/views/ManutencaoContatosUnidadeTelefoniaView.vue'),
    meta: { requiresAuth: true, requiredRole: 'Operador Telefonia' }
  },
  {
    path: '/manutencao-contatos-unidade-celular',
    name: 'manutencao-contatos-unidade-celular',
    component: () => import('@/views/ManutencaoContatosUnidadeCelularView.vue'),
    meta: { requiresAuth: true, requiredRole: ['ADMINISTRADOR','Operador Celular' ]}
  },
  {
    path: '/servidor-lotacao',
    name: 'servidor-lotacao',
    component: () => import('../views/ServidorLotacaoAlteradaView.vue'),
    meta: { requiresAuth: true, requiredRole: ['ADMINISTRADOR', 'Operador Telefonia'] }
  },
  {
    path: '/servidor-lotacao-caps',
    name: 'servidor-lotacao-caps',
    component: () => import('../views/ServidorLotacaoAlteradaCapsView.vue'),
    meta: { requiresAuth: true, requiredRole: 'CAPS' }
  },
  {
    path:'/consulta-contatos',
    name:'consulta-contatos',
    component: () => import('@/views/ConsultaContatosView.vue'),
  },
  {
    path: '/contatos/comarca/:id/:slug',
    name: 'contatos-comarca',
    component: () => import('@/views/ContatoPublicoView.vue'),
    props: route => ({ tipo: 'comarca', id: route.params.id, slug: route.params.slug })
  },
  {
    path: '/contatos/unidade/:id/:slug',
    name: 'contatos-unidade',
    component: () => import('@/views/ContatoPublicoView.vue'),
    props: route => ({ tipo: 'unidade', id: route.params.id, slug: route.params.slug })
  },
  {
    path:'/exportar-contatos',
    name:'exportar-contatos',
    component: () => import('@/views/ExportacaoContatosView.vue'),
    meta: { requiresAuth: true, requiredRole: ['ADMINISTRADOR', 'Operador Telefonia'] }
  },
  {
    path:'/consulta-log',
    name:'consulta-log',
    component: () => import('@/views/ConsultaLogView .vue'),
    meta: { requiresAuth: true, requiredRole: ['ADMINISTRADOR', 'Operador Telefonia'] }
  },
  {
    path:'/manuais',
    name:'manuais',
    component: () => import('@/views/ManuaisView.vue'),
    meta:{requiresAuth: true, requiredRole:['ADMINISTRADOR', 'CAPS', 'Operador Telefonia', 'Operador Celular']}
  },
  {  
    path:'/busca-por-celular',
    name:'busca-por-celular',
    component: () => import('@/views/BuscaPorCelularView.vue'),
    meta: { requiresAuth: true, requiredRole: ['ADMINISTRADOR', 'Operador Celular'] }
  },
  {  
    path:'/ordem-exibicao',
    name:'ordem-exibicao',
    component: () => import('@/views/OrdemExibicaoView.vue'),
    meta: { requiresAuth: true, requiredRole: ['ADMINISTRADOR'] }
  },
  {  
    path:'/complemento-unidade',
    name:'complemento-unidade',
    component: () => import('@/views/ManutencaoComplementoUnidadeView.vue'),
    meta: { requiresAuth: true, requiredRole: ['ADMINISTRADOR'] }
  },
    
];

const router = createRouter({
  history: createWebHistory(),
  routes
})

const SITE_URL = 'https://contatos.tjpa.jus.br'

function atualizarMetadados(to) {
  const nome = to.meta?.titulo || 'Lista de Contatos do TJPA'
  const descricao = to.meta?.descricao ||
    'Consulte telefones, endereços e contatos das unidades do Tribunal de Justiça do Estado do Pará.'
  const canonical = `${SITE_URL}${to.path === '/' ? '/consulta-contatos' : to.path}`

  document.documentElement.lang = 'pt-BR'
  document.title = nome

  let description = document.querySelector('meta[name="description"]')
  if (!description) {
    description = document.createElement('meta')
    description.name = 'description'
    document.head.appendChild(description)
  }
  description.content = descricao

  let link = document.querySelector('link[rel="canonical"]')
  if (!link) {
    link = document.createElement('link')
    link.rel = 'canonical'
    document.head.appendChild(link)
  }
  link.href = canonical
}

router.afterEach(atualizarMetadados)

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('auth_token');
  const userRole = localStorage.getItem('role');
    
  const requiredRole = to.meta.requiredRole;
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next('/login');
    } else {
      if (requiredRole) {
        
        const hasAccess = Array.isArray(requiredRole)
          ? requiredRole.includes(userRole) 
          : userRole === requiredRole;

        if (!hasAccess) {
          next('/home');
        } else {
          next();
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router
